
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workshop",
      function () {
        return require("private-next-pages/workshop/index.js");
      }
    ]);
  